export const prices = {
  start: {
    monthly: {
      default: 39,
    },
    yearly: {
      default: 32,
      forIndian: 32,
    },
  },
  grow: {
    monthly: {
      default: 65,
      isSmallAccount: 65,
    },
    yearly: {
      default: 49,
      isSmallAccount: 49,
      forIndian: 49,
    },
  },
  enterprise: {
    monthly: {
      // default: 94,
      default: 199,
    },
    yearly: {
      default: 149,
      forIndian: 149,
    },
  },
};

export const discounts = {
  grow: {
    default: "GROWINGACCOUNT",
    yearly: "GROWINGACCOUNTYEARLY",
  },
  india: {
    yearly: "", // INDIAYEARLY
    // yearly: "INDIA", // INDIAYEARLY
  },
};